import  {Vue} from '../../addiesaas'

import Meta from 'vue-meta'
import Vue2Filters from 'vue2-filters'
import Vuelidate from 'vuelidate'

Vue.use(Vue2Filters)
Vue.use(Meta)
Vue.use(Vuelidate)
